module.exports = __webpack_public_path__ + "static/media/brx.ce40c245.jpg";